import { render, staticRenderFns } from "./support-ticket.vue?vue&type=template&id=61187ad1"
import script from "./support-ticket.vue?vue&type=script&lang=js"
export * from "./support-ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports